import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "./hooks/useAuth";
import { NotificationsProvider } from "./components/shared/NotificationsProvider";

const container = document.getElementById("root");
if (!container) throw new Error("No #root element found");

createRoot(container).render(
  <StrictMode>
    <NotificationsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </NotificationsProvider>
  </StrictMode>,
);
